@if (control) {
  <mat-slide-toggle
    class="ui-slide-toggle"
    [hideIcon]="true"
    [formControl]="control"
    [required]="required"
    [matTooltip]="tooltip ? (tooltip | translate) : ''"
    [matTooltipClass]="tooltipClass"
    (change)="onChange($event)"
  >
    <mat-icon
      class="ui-slide-toggle__icon"
      aria-hidden="true"
      [class.ui-slide-toggle__icon--checked]="!!control.value"
      [class.ui-slide-toggle__icon--disabled]="control.disabled"
    >
      {{ control.value ? 'check' : 'close' }}
    </mat-icon>
    <span
      class="ui-slide-toggle__label"
      [class.ui-slide-toggle__label--disabled]="control.disabled"
    >
      {{ label }}
    </span>
  </mat-slide-toggle>
}
